<template>
    <div>
        <h2>Test module</h2>
    </div>
</template>
<script>
    import ResourceHelper from "@common/globalization/ResourceHelper";
    import { checkAuth } from "@common/custom";
    import * as AspNetData from "devextreme-aspnet-data-nojquery";
    import { DxButton } from "devextreme-vue/button";
    import { DxColumn, DxDataGrid, DxPager, DxPaging, DxSearchPanel } from "devextreme-vue/data-grid";
    import config from "../../config/config.js";
    export default {
        components: {
            DxDataGrid,
            DxColumn,
            DxButton,
            DxPaging,
            DxPager,
            DxSearchPanel
        },
        data() {
            return {
                authorized: false,
                usersDataSource: [],
                displayMode: "full",
                pageSizes: [5, 10, "all"],
                showPageSizeSelector: true,
                showInfo: true,
                showNavButtons: true,
                accountCookieName: "accountUrl",
                translationKeywords: {
                    firstName: "",
                    lastName: "",
                    userName: "",
                    mailAddress: "",
                    companyName: "",
                    department: "",
                    costCenter: "",
                    userDetail: "",
                    users:"",
                },
            };
        },
        beforeMount() {
            this.authorized = checkAuth('CompanyModules', 'ModuleUserSearch');
        },
        methods: {
            translation: function () {
                this.translationKeywords.firstName = ResourceHelper.getString("firstName");
                this.translationKeywords.lastName = ResourceHelper.getString("lastName");
                this.translationKeywords.userName = ResourceHelper.getString("userName");
                this.translationKeywords.mailAddress = ResourceHelper.getString("mailAddress");
                this.translationKeywords.companyName = ResourceHelper.getString("companyName");
                this.translationKeywords.department = ResourceHelper.getString("department");
                this.translationKeywords.costCenter = ResourceHelper.getString("costCenter");
                this.translationKeywords.userDetail = ResourceHelper.getString("userDetail");
                this.translationKeywords.users = ResourceHelper.getString("users");
            },
            listUsers: function () {
                return AspNetData.createStore({
                    key: "userGuid",
                    loadUrl: `${config.nbCoreApiUrl}/api/users/list?loadOptions=%7B%7D`,
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            "portal-id": getCookie("PortalId"),
                            authorization: "Bearer " + getCookie("ApiToken"),
                            "portal-culture": getCookie("Esperantus_Language_languageSwitcher"),
                        };
                    },
                });
            },
            getAllUsers: function () {
                this.usersDataSource = this.listUsers();
            },
            getCookie: function (cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            },
            getAccountPageUrl: function (userguid) {
                let self = this;
                /**** Sample accountUrl: /site/23/Default.aspx ****/
                let hostname = location.hostname;
                let accountUrl = self.getCookie(self.accountCookieName);
                let segments = accountUrl.split("/");
                let editFlag = "EditCorporateUser__true";

                let segmentsArray = [];
                //segmentsArray.push(hostname);
                segmentsArray.push(segments[1]);
                segmentsArray.push(editFlag);
                segmentsArray.push(`UserGuid__${userguid}`);
                segmentsArray.push(segments[2]);
                segmentsArray.push(segments[3]);
                return `/${segmentsArray.join('/')}`;
            },
            openInNewTab: function (userguid) {
                let self = this;
                let url = self.getAccountPageUrl(userguid);
                window.open(url, '_blank').focus();
            }
        },
        created: function () {
            this.translation();
            this.getAllUsers();
        },
    };
</script>
<style scoped>
    .user-detail-btn {
        border-radius: 0 !important;
    }

    #gridContainer {
        margin-top: 40px !important;
    }
</style>